import styled from 'styled-components'

export const ListHeaderStyled = styled.div`
  padding: ${({ theme }) => `${theme.space.small} 0`};
  border-bottom: 1px solid ${({ theme }) => theme.colors.content.border};
`
